import Session from '../../pwjs/src/lib/Session';

const DEFAULT_SESSION_COOKIE_NAME = 'oryx_session_cookie';

function getCookieValue(name) {
  const matches = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
  return matches ? matches.pop() : '';
}

function deleteCookie(name) {
  document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

let instance = null;

class CookieLogin {
  constructor(options) {
    if (instance) {
      return instance;
    }

    options = options || {};
    const cookieName = options.sessionCookieName || DEFAULT_SESSION_COOKIE_NAME;
    const sessionId = getCookieValue(cookieName);

    sessionId && Session.set(sessionId);
    deleteCookie(cookieName);
    instance = this;
  }
}

CookieLogin.pluginName = 'CookieLogin';

CookieLogin.load = function(data) {
  return new CookieLogin(data.options);
}

export default Object.freeze(CookieLogin);
